export default __webpack_public_path__ + "f5f098753d763f9301e9ff7ee4740e32.png";